export default {
  pendingApproval: {
    title: 'Account Approval is Pending',
    body: 'Your account is under review and expected to be complete within 24 hours. Posting jobs is temporarily unavailable, but please contact support with any questions.'
  },
  overCreditLimit: {
    title: 'Credit Limit Issue',
    body: 'Your company has reached your limit of %displayCreditLimit% and you can no longer post jobs. Please contact support'
  },
  approachingCreditLimit: {
    title: 'Approaching Credit Limit',
    body: 'You are approaching your company’s limit of %displayCreditLimit%. You are currently at %currentBalance% and once you hit your limit, you will not be able to post jobs.'
  },
  suspendedPaymentMethod: {
    title: 'Payment Issue',
    body: 'There was an issue with your credit card on file. You cannot post jobs until your payment method is updated. ',
    action: 'Update your payment method'
  },
  noPaymentMethod: {
    title: 'Payment Method Required',
    notice: 'You must ',
    action: 'add a payment method',
    postJobs: ' in order to post jobs.'
  }
};
